import React, { useState, useEffect } from 'react';
import { getProductByHandle } from '../../../../../components/shared/query/query';
import { primeColorOrder, processSpecialColorName } from '../../../../ProductPage/ProductHelpers';
import { useLazyQuery } from '@apollo/client';
import { productDetailViewEvent } from '../../../../../components/shared/dataLayer/index';
import { Swiper, Slide } from 'react-dynamic-swiper';
import 'react-dynamic-swiper/lib/styles.css';
import SizeChart from '../../../../ProductPage/ProductForm/SizeChartModal/SizeChart';
import { hatData } from './quizData';
import './Hat.scss';
import { addToCart, giftsDefault } from '../../../../../components/shared/cart/CartHelpers';
import { productDataParser, productSizeParser } from '../../../../ProductPage/ProductHelpers';
import { clone } from 'lodash';
export default function GiftHat(props) {
  const [getProductByHandleQuery, { data: getProductByHandleData, error: getProductByHandleError }] = useLazyQuery(
    getProductByHandle,
  );
  const [baseProductData, setBaseProductData] = useState({
    images: {
      edges: [],
    },
  });
  const [data, setData] = useState({});
  const [first, setFirst] = useState(false);
  const [colorHandle, setColor] = useState('');
  const [colors, setColors] = useState();
  const [imgData, setImgData] = useState(
    'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-81.jpg?v=1600163137&quot',
  );
  const [vatTextState, setVatTextState] = useState(false);
  const [manOrWoman, setManOrWoman] = useState();
  const [productCode, setProductCode] = useState('');
  const [hasExceededQuantity, setHasExceededQuantity] = useState(false);
  const [errorState, setErrorState] = useState({
    message: '',
    show: false,
  });
  const [variant, setVariant] = useState();

  useEffect(() => {
    if (props.handle) {
      getProductByHandleQuery({
        variables: {
          handle: props.handle,
          currencyCode: 'EUR',
        },
      });
    }
  }, [props.handle]);

  useEffect(() => {
    if (baseProductData) {
      const result = productDataParser(baseProductData, giftsDefault);
      if (result) {
        setData(result);
      }
    }
  }, [baseProductData]);

  useEffect(() => {
    if (getProductByHandleError) {
    }
    if (getProductByHandleData) {
      if (!getProductByHandleData.productByHandle) {
        window.location.replace(`${window.location.origin}/404`);
        return null;
      }

      let product = JSON.parse(JSON.stringify(getProductByHandleData.productByHandle));
      product = handleProductData(product);
      setBaseProductData(product);
    }
  }, [getProductByHandleData, getProductByHandleError]);

  function handleProductData(product) {
    let firstAvailableSizeFound = false;
    product.sizeValues = [];
    product.variants.edges.map((variant, index) => {
      if (!firstAvailableSizeFound && variant && variant.node && variant.node.availableForSale) {
        setVariant(variant.node);
      }
      variant.node.selectedOptions.map((selectedOption) => {
        if (selectedOption.name === 'Size') {
          let chosen = false;
          if (!firstAvailableSizeFound && variant.node.availableForSale) {
            firstAvailableSizeFound = true;
            chosen = true;
            product.chosenSizeAvailability = variant.node.availableForSale;
          }
          product.sizeValues.push({
            chosen,
            value: selectedOption.value,
            availableForSale: variant.node.availableForSale,
            quantityAvailable: variant.node.quantityAvailable,
          });
        } else if (index === 0 && selectedOption.name === 'Color') {
          product.chosenColorValue = selectedOption.value;
        }
        return null;
      });
      return null;
    });
    let chosenColorValueProcessed;

    if (product.chosenColorValue) {
      chosenColorValueProcessed = processSpecialColorName(product.chosenColorValue);
    } else {
      chosenColorValueProcessed = '';
    }
    product.colorValues = [];
    let selfPicked = false;
    for (const singleColorOrder of primeColorOrder) {
      if (chosenColorValueProcessed === singleColorOrder) {
        selfPicked = true;
        product.colorValues.push({
          name: chosenColorValueProcessed,
          handle: `${product.handle}`,
          chosen: true,
        });
      }

      for (let variant of product.variants.edges) {
        if (variant && variant.node && variant.node.availableForSale !== false) {
          let color = '';
          variant.node.selectedOptions.map((selectedOption) => {
            if (selectedOption.name === 'Color') {
              color = selectedOption.value === 'ebony' ? '' : selectedOption.value;
            }
          });
          if (singleColorOrder === color) {
            product.colorValues.push({
              name: color,
              handle: `${product.handle}`,
              chosen: false,
            });
          }
        }
      }
    }

    if (!selfPicked) {
      product.colorValues.push({
        name: chosenColorValueProcessed,
        handle: `${product.handle}`,
        chosen: true,
      });
    }

    if (product && product.variants && product.variants.edges) {
      let colorsMap = {};

      for (let variant of product.variants.edges) {
        if (variant && variant.node && variant.node.availableForSale !== false) {
          let color = '';
          variant.node.selectedOptions.map((selectedOption) => {
            if (selectedOption.name === 'Color') {
              color = selectedOption.value;
            }
          });
          if (colorsMap[color] && Array.isArray(colorsMap[color])) {
            colorsMap[color].push(variant);
          } else {
            colorsMap[color] = [variant];
          }
        }
      }
      setColors(colorsMap);
    }

    return product;
  }

  let ProductPriceHelper = null;
  if (baseProductData.id) {
    ProductPriceHelper = (
      <div className="tc_product_price">
        {baseProductData.variants.edges[0].node.presentmentPrices &&
          baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.compareAtPrice && (
            <div className="gr_left">
              {baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.compareAtPrice.amount &&
              baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.compareAtPrice.amount &&
              parseInt(baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.compareAtPrice.amount) >
                parseInt(baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.price.amount) ? (
                <div className="productPrice">
                  <div className="pr_price">
                    <p className="current_price">
                      {'€'}
                      {parseInt(
                        baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.compareAtPrice.amount,
                        10,
                      )}
                    </p>
                    {vatTextState === true && <span> inkl. MwSt. exkl. Versand </span>}
                  </div>
                </div>
              ) : (
                <div className="productPrice current">
                  <p>
                    {'€'}
                    {parseInt(baseProductData.variants.edges[0].node.presentmentPrices.edges[0].node.price.amount, 10)}
                    .00
                  </p>
                  {vatTextState === true && <span> inkl. MwSt. exkl. Versand</span>}
                </div>
              )}
            </div>
          )}
      </div>
    );
  }

  let changeColor = (color) => {
    let colorImg =
      color === 'ebony'
        ? 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-81.jpg?v=1600163137&quot'
        : color === 'beige'
        ? 'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087--02.jpg?v=1600163134'
        : '';
    setImgData(colorImg);
    const clonedProductData = JSON.parse(JSON.stringify(baseProductData));
    clonedProductData.chosenColorValue = color;
    for (const singleSize of clonedProductData.colorValues) {
      singleSize.chosen = false;
      if (singleSize.name === color) {
        singleSize.chosen = true;
      }
    }

    for (let imgChange of clonedProductData.images.edges) {
      let img =
        color === 'ebony'
          ? (imgChange.node.originalSrc =
              'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087-81.jpg?v=1600163137&quot')
          : color === 'beige'
          ? (imgChange.node.originalSrc =
              'https://cdn.shopify.com/s/files/1/0249/6551/3262/products/1020087--02.jpg?v=1600163134')
          : '';
      clonedProductData.images.edges[0].node.originalSrc = img;
    }

    setBaseProductData(clonedProductData);
    let chosenVariant;
    clonedProductData.variants.edges.map((variant) => {
      variant.node.selectedOptions.map((selectedOption) => {
        if (selectedOption.value === color) {
          chosenVariant = variant.node;
          setVariant(chosenVariant);
        }
      });
    });
  };

  return (
    <div className="hat-slider">
      <div className="shipp-gift_box">
        <div className="img">
          <div className="first_img">
            <img
              alt="gobi"
              style={{ width: '100%' }}
              srcSet={
                `${imgData.replace('.jpg', '_260x.jpg')} 260w,` +
                `${imgData.replace('.jpg', '_390x.jpg')} 390w,` +
                `${imgData.replace('.jpg', '_468x.jpg')} 468w,` +
                `${imgData.replace('.jpg', '_560x.jpg')} 560w,` +
                `${imgData.replace('.jpg', '_640x.jpg')} 640w,` +
                `${imgData.replace('.jpg', '_750x.jpg')} 750w,` +
                `${imgData.replace('.jpg', '_828x.jpg')} 828w,` +
                `${imgData.replace('.jpg', '_1080x.jpg')} 1080w,` +
                `${imgData.replace('.jpg', '_1280x.jpg')} 1280w,`
              }
              width="288"
            />
          </div>
        </div>
      </div>
      <div className="production-detail-style">
        {baseProductData && (
          <>
            <p style={{ textTransform: 'capitalize' }}>Rippmütze</p>
            <div className="production-shipp-price">{ProductPriceHelper ? ProductPriceHelper : ''}</div>
            <div className="clothe-heading">
              <div className="coup-clothe-product">
                {baseProductData && baseProductData.id && baseProductData.variants && (
                  <>
                    <div className="clothe_color">
                      <div className="colorTitle">
                        <p>
                          Farbe
                          <span>
                            -{' '}
                            {baseProductData.id && baseProductData.variants && (
                              <span style={{ textTransform: 'capitalize' }}>{baseProductData.chosenColorValue}</span>
                            )}
                          </span>
                        </p>
                      </div>
                      <div className="colorVarientForm">
                        {baseProductData.colorValues.map((item, i) => (
                          <span key={i}>
                            {item.chosen ? (
                              <div key={i} className="singleColorVariantBox" style={{ border: '1px solid #18a0fb' }}>
                                <div
                                  className="innerSingleColorBox"
                                  style={{
                                    backgroundImage: `url(https://cdn.shopify.com/s/files/1/0249/6551/3262/t/44/assets/${item.name}_50x.png?v=)`,
                                  }}
                                ></div>
                              </div>
                            ) : item.name === 'ebony' || item.name === 'beige' ? (
                              <div key={i} className="singleColorVariantBox">
                                <div
                                  className="innerSingleColorBox"
                                  style={{
                                    backgroundImage: `url(https://cdn.shopify.com/s/files/1/0249/6551/3262/t/44/assets/${item.name}_50x.png?v=)`,
                                  }}
                                  onClick={() => changeColor(item.name)}
                                />
                              </div>
                            ) : (
                              ''
                            )}
                          </span>
                        ))}
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="modal-price-total">
                <div className="btn">
                  <button
                    aria-label={'In den Warenkorb'}
                    className="addToCartBtn"
                    disabled={props.hasExceededQuantity}
                    onClick={() => {
                      props.AddToCard(true);
                      addToCart(variant, giftsDefault, baseProductData);
                    }}
                  >
                    {'In den Warenkorb'}
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
